<template>
  <div class="text-left">
    <div class="row">
      <div class="col">
        <b-form-group
          id="fieldset-1"
          label="Street Address"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="street"
            :state="isElementValid('street')"
            required
            @blur="onBlur('street')"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form-group
          id="fieldset-2"
          label="City"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="city"
            :state="isElementValid('city')"
            required
            @blur="onBlur('city')"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group
          id="fieldset-3"
          label="State"
          label-for="input-3"
        >
          <b-form-select
            id="input-3"
            v-model="state"
            :options="states"
            :state="isElementValid('state')"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>Select State</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group
          id="fieldset-4"
          label="Zip Code"
          label-for="input-4"
        >
          <b-form-input
            id="input-4"
            v-model="zip"
            :state="isElementValid('zip')"
            @blur="onBlur('zip')"
            required
            trim
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div v-if="isDisabled">&nbsp;</div>
  </div>
</template>
<script>
import stateNames from '@/json/states.json';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { getMapBoxObjectFromForm } from "@/utils";

export default {
  name: 'AddressForm',
  computed: {
    address() {
      return this.street && this.city && this.state && this.zip ? 
      `${this.street} ${this.city}, ${this.state} ${this.zip}, ${this.country}` : ''
    },
    isDisabled() {
      if (!this.$v.$invalid) {
        const addressParts = getMapBoxObjectFromForm(this.address, 
          this.street, this.city, this.state, this.zip);
        this.$emit('on-success', addressParts);
      } else {
        this.$emit('on-invalid');
      }
      return this.$v.$invalid;
    }
  },
  validations: {
    street: { required },
    city: { required },
    state: {
      required,
      minLength: minLength(3)
    },
    zip: {
      required,
      maxLength: maxLength(5),
      minLength: minLength(5)
    },
  },
  methods: { 
    isElementValid: function (field) {
      const vFormElement = this.$v[field];
      if (!vFormElement) {
        return null;
      }
      if (!vFormElement.$dirty) {
        if (vFormElement.$model) this.$v[field].$touch();
        return null;
      }
      if (vFormElement.$invalid) {
        return false;
      }
      if (!vFormElement.$invalid && vFormElement.$dirty) {
        return true;
      }
      return null;
    },
    onBlur(field) {
      this.$v[field].$touch();
    }
   },
  data() {
    return {
      street: null,
      city: null,
      state: null,
      zip: null,
      country: 'United States',
      states: stateNames.map(x => x.name),
      isValid: false
    }
  }
}
</script>
<style scoped>
select .is-valid {
  border-color: #28a745;
}
select:-webkit-autofill,
select:-webkit-autofill:hover, 
select:-webkit-autofill:focus, 
select:-webkit-autofill:active,
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
</style>